import { render, staticRenderFns } from "./PrimaryContactDetails.vue?vue&type=template&id=0b05c5eb"
import script from "./PrimaryContactDetails.vue?vue&type=script&lang=js"
export * from "./PrimaryContactDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports